export default __webpack_public_path__ + "static/media/AnyConv.com__Inter-Medium.ff01ee2f.ttf";